import FluxUtils from 'flux/utils';

import SettingsStore from 'sharedreact/stores/SettingsStore';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import TokensActions from 'workspaces/launcher/actions/TokensActions';
import CopyTokenDialog from 'workspaces/launcher/components/admin/CopyTokenDialog';
import TokensStore from 'workspaces/launcher/stores/TokensStore';
import asFunctional from 'sharedreact/components/asFunctional';

type Props = {
  userName: string
};

type State = ConstructorParameters<typeof CopyTokenDialog>[0];

function getStores () {
  return [
    SettingsStore,
    TokensStore
  ];
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  return {
    language: SettingsStore.getLanguage(),
    show: TokensStore.getShowCopyButton(),
    userName: props.userName,
    canCopyToClipboard: TokensStore.canCopyToClipboard(),
    copyData: TokensStore.getCopyData(),
    onCopy: TokensStore.copyTokenToClipboard,
    onClose: TokensActions.hideCopyButton
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(CopyTokenDialog),
  getStores,
  calculateState,
  { withProps: true }
);
